import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";

interface RootRouteProps {
  landing: ReactNode;
  dashboard: ReactNode;
}

export function RootRoute({ landing, dashboard }: RootRouteProps) {
  const { user, loading } = useAuth();

  // Главная страница должна открываться даже если авторизация/бекенд
  // временно недоступны в сети пользователя. Не держим публичный лендинг
  // на тёмном экране ожидания — показываем его сразу, а dashboard включится,
  // когда локальная сессия пользователя будет подтверждена.
  if (!user || loading) {
    return <>{landing}</>;
  }

  return <>{dashboard}</>;
}
